function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
//
//
//
//
//
//
//
//
//
//

import { get, setBaseURL, getQuery } from '@changba/funny';
import Table from '../table';
import { defineComponent } from '../utils/create';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "egg-item"
  }, [_vm._t("title", function () {
    return [_c('span', {
      staticClass: "egg-title"
    }, [_vm._v(_vm._s(_vm.eggName) + " " + _vm._s(_vm.eggPrice) + "金币/钻石")])];
  }, {
    "eggName": _vm.eggName,
    "eggPrice": _vm.eggPrice
  }), _vm._v(" "), _c('cb-table', {
    staticClass: "egg-table",
    attrs: {
      "columns": _vm.tableColumns,
      "data": _vm.eggData
    }
  }), _vm._v(" "), _vm._t("separate")], 2);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-3c23e73c',
  render,
  name: 'CbEggItem',
  components: {
    CbTable: Table
  },
  props: {
    eggId: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    eggColumns: {
      type: Array,
      required: true,
      default: () => [{
        label: '礼物名称',
        prop: 'name',
        align: 'center'
      }, {
        label: '礼物价值',
        prop: 'price',
        align: 'center'
      }, {
        label: '概率(‱)',
        prop: 'rate',
        width: '18%',
        noWrap: 'wrap',
        align: 'center'
      }]
    },
    formatter: {
      type: Function,
      required: false
    },
    sort: {
      type: [String, Object, undefined],
      default: undefined
    },
    isPreview: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      selfEggColumns: [{
        label: '礼物名称',
        prop: 'name',
        align: 'center'
      }, {
        label: '礼物价值',
        prop: 'price',
        align: 'center'
      }, {
        label: '概率(‱)',
        prop: 'rate',
        width: '18%',
        noWrap: 'wrap',
        align: 'center'
      }],
      eggData: [],
      eggName: '',
      eggPrice: 0
    };
  },
  computed: {
    tableColumns() {
      return Object.assign(this.selfEggColumns, this.eggColumns);
    }
  },
  beforeCreate() {
    // 只针对在@changba/component预览的时候用到
    if (['site-dev', 'site-prod'].includes(process.env.NODE_ENV) || getQuery('isMock')) {
      setBaseURL('https://yapi.changbaops.com/mock/32/www');
    }
  },
  mounted() {
    this.getEggConfig();
  },
  methods: {
    getEggConfig() {
      var _this = this;
      return _asyncToGenerator(function* () {
        // 如果是预览模式，则打到yapi上看数据
        if (_this.isPreview) {
          setBaseURL('https://yapi.changbaops.com/mock/32/www');
        }
        var resp = yield get({
          url: '/api/automan/cfg/activity/egg',
          ignoreBaseURL: true,
          data: {
            [_this.type === 'work' ? 'workEgg' : 'roomEgg']: _this.eggId
          }
        });
        if (resp.code === 1) {
          var {
            name = '',
            coins = 0,
            gifts = []
          } = resp.data;
          // 新老结构抹平
          var eggData = gifts.map(v => {
            var _v$gift;
            var {
              chance
            } = v;
            return _extends({
              rate: chance,
              price: ((_v$gift = v.gift) == null ? void 0 : _v$gift.coins) || 0
            }, v.gift || {});
          });
          _this.eggName = name;
          _this.eggPrice = coins;
          var tempEggData = typeof _this.formatter === 'function' ? eggData.map(v => _this.formatter(v)) : eggData;
          if (_this.sort === 'asc') {
            tempEggData.sort((a, b) => {
              return a.rate - b.rate;
            });
          } else if (_this.sort === 'desc') {
            tempEggData.sort((b, a) => {
              return a.rate - b.rate;
            });
          } else if (typeof _this.sort === 'object' && _this.sort != null) {
            if (_this.sort.direction === 'asc') {
              tempEggData.sort((a, b) => {
                return a[_this.sort.prop] - b[_this.sort.prop];
              });
            } else if (_this.sort.direction === 'desc') {
              tempEggData.sort((b, a) => {
                return a[_this.sort.prop] - b[_this.sort.prop];
              });
            }
          }
          _this.eggData = tempEggData;
        } else {
          var msg = resp.msg || '获取彩蛋配置失败，请稍候再试试吧~';
          _this.toast(msg);
        }
      })();
    },
    toast(msg) {
      if (typeof this.$toast === 'function') {
        this.$toast(msg);
      } else if (typeof this.$Toast === 'function') {
        this.$Toast(msg);
      } else {
        // eslint-disable-next-line no-alert
        alert(msg);
      }
    }
  }
});